export default "__VITE_ASSET__495ac9a8__"